/**
 * Shared OTP validity timer (display only; Cognito still enforces its own code lifetime).
 * The expiry is kept in sessionStorage so the countdown survives a page refresh.
 */

/** How long an OTP is shown as valid, and how long Resend stays disabled. */
export const OTP_VALIDITY_SECONDS = 3 * 60;

const OTP_TIMER_KEY_PREFIX = "nova_otp_timer_";

/** Start a fresh OTP timer for a flow (e.g. "reset") and remember the email it was sent to. */
export const startOtpTimer = (flow, email = "") => {
  const expiresAt = Date.now() + OTP_VALIDITY_SECONDS * 1000;
  try {
    sessionStorage.setItem(
      `${OTP_TIMER_KEY_PREFIX}${flow}`,
      JSON.stringify({ expiresAt, email }),
    );
  } catch {
    // Storage unavailable: the in-memory timer still works, it just will not survive a refresh.
  }
  return expiresAt;
};

/** Return `{ expiresAt, email }` for a flow if its timer is still running, otherwise null. */
export const getOtpTimer = (flow) => {
  try {
    const raw = sessionStorage.getItem(`${OTP_TIMER_KEY_PREFIX}${flow}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && Number(parsed.expiresAt) > Date.now()) {
      return { expiresAt: Number(parsed.expiresAt), email: parsed.email || "" };
    }
    sessionStorage.removeItem(`${OTP_TIMER_KEY_PREFIX}${flow}`);
  } catch {
    // Corrupt or unavailable storage is treated as "no active timer".
  }
  return null;
};

/** Forget a flow's OTP timer (after success, going back, or expiry). */
export const clearOtpTimer = (flow) => {
  try {
    sessionStorage.removeItem(`${OTP_TIMER_KEY_PREFIX}${flow}`);
  } catch {
    // Nothing to clear if storage is unavailable.
  }
};
